// import { register } from 'swiper';
// import { register } from 'swiper/element';
// import { Scrollbar, FreeMode, Autoplay, EffectFade, Mousewheel } from 'swiper';
// import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, FreeMode, EffectFade, Mousewheel } from 'swiper';
import { merge } from 'lodash-es';
import { getClosest, str2json } from '@utils';
import delegate from 'delegate';

export class Slider {
  constructor(el, ctx) {
    this.init(el);
  }
  connectedCallback() {}
  init(el) {
    let defaults = {
      slidesPerView: 'auto',
      spaceBetween: 16,
      centeredSlides: false,
      navigation: true,
      // modules: [Autoplay, Scrollbar, FreeMode, EffectFade, Mousewheel, Navigation, Pagination],
      // theme: 'default',
      // If we need pagination
      multirow: false,
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    };

    let instanceOptions = str2json(el.dataset.options);
    let options = merge(defaults, instanceOptions);
    // console.log('options', options);
    let scrollbarStyles = [
      `:host .swiper-scrollbar {
        height: 4px;
        width: var(--scrollbar-width);
        background: var(--scrollbar-bg);
        margin: 3rem 0;
        border-radius: 4px;
      }
      :host .swiper-scrollbar-drag {
        height: 4px;
        background: var(--scrollbar-cursor);
        border-radius: 4px;
      }
      `,
      `.swiper-wrapper { transition-timing-function: linear !important }`,
    ];

    const swiperParams = options;
    this.options = swiperParams;
    this.swiper = new Swiper(el, swiperParams);
  }

  bindEvents() {
    let parent = this.options.parentController
      ? getClosest(this.el, this.options.parentController) || this.el.parentNode
      : this.el.parentNode;

    // If slide buttons mark the first as active on load
    let slideButtons = parent?.querySelectorAll('.select-slide');
    if (slideButtons.length > 0) {
      slideButtons[0].classList.add('active');
    }

    delegate(parent, '.previous-slide', 'click', (e) => {
      e.preventDefault();
      this.el.swiper.slidePrev();
    });

    delegate(parent, '.next-slide', 'click', (e) => {
      e.preventDefault();
      this.el.swiper.slideNext();
    });

    delegate(parent, '.select-slide', 'click', (e) => {
      e.preventDefault();
      // Get the index number of the clicked slide
      // and select the corresponding slider item
      let slides = parent.querySelectorAll('.select-slide');
      let index = Array.from(slides).indexOf(e.target);
      this.el.swiper.slideTo(index);
    });

    // this.el.swiper.wrapperEl.style.transitionTimingFunction = 'linear';

    this.el.swiper.on('slideChange', () => {
      let activeSlide = this.el.swiper.activeIndex;
      let slides = parent.querySelectorAll('.select-slide');
      slides.forEach((slide, index) => {
        if (index === activeSlide) {
          slide.classList.add('active');
        } else {
          slide.classList.remove('active');
        }
      });
    });
  }
}
